import React, { useState } from 'react';
import { OrganizationPathName } from '~/organizations/organization-path-name';
import { useSirenEntity, sirenActions, entityStore, store, storeActions } from '~/utility/BinSentry-ui-utility';
import {
  makeStyles,
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  FormGroup,
  TextField,
} from '~/lib/bn-material-ui';
import { BnDialog } from '~/common';

const useStyles = makeStyles(() => {
  return {
    contentContainer: {
      display: 'flex',
      alignItems: 'baseline',
      whiteSpace: 'normal',
    },
    pathContainer: {
      flex: 1,
      marginLeft: '1em',
    },
  };
});

export default function AddBinDialog({ href, show, handleClose }) {
  const styles = useStyles();
  const { entity: orgEntity } = useSirenEntity({ href: href });
  const { entity: binsEntity } = useSirenEntity({
    href: orgEntity?.getSubEntityByRel('https://api.binsentry.com/rel/bins').href,
  });
  const [name, setName] = useState('');
  const [createdBinId, setCreatedBinId] = useState('');
  const [error, setError] = useState('');

  if (!(binsEntity && orgEntity)) {
    return null;
  }

  const handleChange = (event) => {
    setName(event.target.value);
    error && setError('');
  };

  const goToBin = (href) => {
    handleClose();
    store.dispatch(storeActions.navigate(`/bins/show?binId=${encodeURIComponent(href)}`));
  };

  const reset = () => {
    setName('');
    setCreatedBinId('');
    setError('');
  };

  const createBin = async (name) => {
    const action = binsEntity.getAction('add-bin');
    const fields = sirenActions.getActionFields(action);
    fields.set('name', name);
    try {
      const newBin = await sirenActions.submitAction(action, fields);
      await Promise.all([
        entityStore.invalidateHref(orgEntity.getLinkByRel('self').href),
        entityStore.invalidateHref(orgEntity.getSubEntityByRel('https://api.binsentry.com/rel/bins').href),
      ]);
      setCreatedBinId(newBin.entity.getLinkByRel('self').href);
    } catch (e) {
      setError(e.message || 'An unexpected error has occurred.');
    }
  };

  return (
    <BnDialog
      open={show}
      onClose={handleClose}
      title='Add Bin'
      disableEnforceFocus
      overrideDialogActions
    >
      <DialogContent>
        <div className={styles.contentContainer}>
          <span>Adding Bin into:</span>
          <span className={styles.pathContainer}>
            <OrganizationPathName organizationHref={href} />
          </span>
        </div>
        <FormGroup>
          <FormControl margin='normal'>
            <TextField
              error={!!error}
              value={name}
              helperText={error || 'Bin Name'}
              onChange={handleChange}
              disabled={!!createdBinId}
            />
          </FormControl>
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={() => {
            reset();
            handleClose();
          }}
        >
          {createdBinId ? 'Close' : 'Cancel'}
        </Button>
        {
          createdBinId &&
          <Button
            variant='outlined'
            onClick={() => reset()}
          >Create Another Bin
          </Button>
        }
        <Button
          variant='contained'
          disabled={!name || error}
          onClick={() => {
            createdBinId
              ? goToBin(createdBinId)
              : createBin(name);
          }}
        >
          {createdBinId ? 'Go to Bin' : 'Save'}
        </Button>
      </DialogActions>
    </BnDialog>
  );
}
